(function () {
  // How many extra pages to auto-load (protects performance).
  // Set to 0 for manual button only, or a higher number if you want more.
  const MAX_AUTO_REQUESTS = 6; // loads up to 6 extra pages (~6 * page size)
  let autoLoads = 0;
  let observer;

  function attachObserver(btn) {
    if (!('IntersectionObserver' in window) || !btn) return;

    if (observer) observer.disconnect();
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && autoLoads < MAX_AUTO_REQUESTS && !btn.disabled) {
          btn.click(); // trigger the same handler as manual click
          autoLoads++;
        }
      });
    }, { rootMargin: '600px 0px 600px 0px' }); // prefetch before reaching the button

    observer.observe(btn);
  }

  function onClick(e) {
    const btn = e.target.closest('#LoadMore');
    if (!btn) return;

    e.preventDefault();
    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = 'Loading…';

    fetch(btn.dataset.next, { credentials: 'same-origin' })
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        // Your grid id is confirmed as #product-grid in your template
        const grid = document.querySelector('#product-grid');
        const newItems = doc.querySelectorAll('#product-grid > *');

        if (!grid || newItems.length === 0) {
          btn.remove();
          if (observer) observer.disconnect();
          return;
        }

        newItems.forEach((el) => grid.appendChild(el));

        // Find the next button/url from the fetched page
        const nextBtn = doc.querySelector('#LoadMore');
        if (nextBtn && nextBtn.dataset.next) {
          btn.dataset.next = nextBtn.dataset.next;
          btn.disabled = false;
          btn.textContent = originalText;

          // Reattach observer so it keeps auto-loading
          attachObserver(btn);
        } else {
          // No more pages
          btn.remove();
          if (observer) observer.disconnect();
        }
      })
      .catch(() => {
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  document.addEventListener('click', onClick);

  // When the page loads, if a Load More button exists, start observing it.
  document.addEventListener('DOMContentLoaded', () => {
    const btn = document.querySelector('#LoadMore');
    attachObserver(btn);
  });
})();
